<div class="container mt-0 flex-auto flex-col" [class.mb-6]="isAllColumns" [class.mx-10]="isAllColumns">
  <!-- Export Button -->
  <div class="flex justify-end mb-2">
    <button mat-icon-button color="primary" (click)="onExportButtonPressed()" matTooltip="Exportar">
      <mat-icon [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
    </button>
  </div>

  <!-- Smart Grid -->
  <div class="w-full bg-white">
    <app-smart-grid
      class="w-full"
      [data]="summaryData || []"
      [columnDefs]="columnDefs"
      [config]="gridConfig">
    </app-smart-grid>
  </div>

  <!-- Footer with Totals -->
  <div *ngIf="summaryData && summaryData.length > 0"
       class="w-full bg-gray-50 border-t-2 border-gray-300 px-4 py-4">
    <div class="flex justify-between items-center">
      <!-- Label -->
      <div class="font-bold text-sm">
        TOTAL
      </div>

      <!-- Totals -->
      <div class="text-sm" >
        <div>
          <span class="font-semibold">UMB:</span>
          {{ getTotalBaseQuantity() | number: '1.3' }}
          <span *ngIf="getCommonBaseUnit()" class="text-gray-500">
            ({{ getCommonBaseUnit() }})
          </span>
        </div>
        <div *ngIf="UMPActive">
          <span class="font-semibold">UMP:</span>
          {{ getTotalPararellQuantity() | number: '1.3' }}
          <span *ngIf="getCommonParallelUnit()" class="text-gray-500">
            ({{ getCommonParallelUnit() }})
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!summaryData || summaryData.length === 0"
       class="border-t p-8 text-center text-1xl sm:p-10">
    Lo sentimos, no hay registros para mostrar.
  </div>
</div>
